import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { isNativePlatform } from '../native/platform';
import { hapticLight } from '../native/haptics';

const TABS = [
  {
    name: 'Home',
    path: '/',
    end: true,
    ariaLabel: 'Go to home',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    name: 'Discover',
    path: '/events',
    ariaLabel: 'Discover events',
    icon: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z',
  },
  {
    name: 'Tickets',
    path: '/attendee/tickets',
    ariaLabel: 'View my tickets',
    icon: 'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z',
  },
  {
    name: 'Saved',
    path: '/saved',
    ariaLabel: 'View saved events',
    icon: 'M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z',
  },
  {
    name: 'Profile',
    path: '/attendee',
    ariaLabel: 'View profile',
    icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
  },
];

const MobileTabBar = () => {
  const native = isNativePlatform();

  useEffect(() => {
    if (!native) return;
    const prev = document.body.style.paddingBottom;
    document.body.style.paddingBottom = 'calc(4rem + env(safe-area-inset-bottom))';
    return () => {
      document.body.style.paddingBottom = prev;
    };
  }, [native]);

  if (!native) return null;

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur border-t border-gray-200 dark:border-gray-800 shadow-sm"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary navigation"
    >
      <div className="flex items-stretch justify-around h-16">
        {TABS.map((tab) => (
          <NavLink
            key={tab.name}
            to={tab.path}
            end={tab.end}
            aria-label={tab.ariaLabel}
            onClick={() => hapticLight()}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 gap-0.5 text-[11px] font-medium transition-colors duration-150 min-h-[48px] ${
                isActive
                  ? 'text-primary'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <svg
                  className={`w-6 h-6 transition-transform duration-200 ${isActive ? 'scale-110' : ''}`}
                  fill={isActive ? 'currentColor' : 'none'}
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={tab.icon} />
                </svg>
                {tab.name}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileTabBar;
